import { Icon } from "@/components/icon/Icon";
import "./table.css";
import type { Column } from "@/types/array.types";


interface TableProps<T> {
    columns: Column<T>[];
    dataArray: T[];
    role: string
    onDelete?: (id: string) => void;
    onEdit?: (id: number) => void;
}

export function Table<T extends Record<string, any>>({columns, dataArray, role, onDelete, onEdit}: TableProps<T>) {
    return <table>
    <thead className={"table-header"}>
        <tr>
        {columns.map((column, index) => {
            return  column.key != "id" && <th key={`header_${index}`}> {column.label}</th>
        })}
        {(role == "editor" || role == "admin")  && <th>Actions</th>}
        </tr>
    </thead>
    <tbody className={"table-body"}>
        {dataArray?.map((data, rowIndex) => (
          <tr className="table-row" key={rowIndex}>
            {columns.map((column, colIndex) => (
              column.key != "id" &&
              <td key={colIndex}>
                 {column.render
                    ? column.render(data)
                    : String(data[column.key])}              
              </td>
            ))}
             {(role == "editor" || role == "admin") && <td className="column-actions">
              <div onClick={() => onEdit(rowIndex)}><Icon className={"table-icon icon-edit"} name={"edit"}/></div>
              <div onClick={() => onDelete(data["id"])}><Icon className={"table-icon icon-delete"} name={"delete"}/></div>
             </td> }
          </tr>
        ))}
      </tbody>
    </table>
    
};